import { render, staticRenderFns } from "./SvgLogo.html?vue&type=template&id=7f4d1b0c&scoped=true&"
import script from "./SvgLogo.js?vue&type=script&lang=js&"
export * from "./SvgLogo.js?vue&type=script&lang=js&"
import style0 from "./SvgLogo.scss?vue&type=style&index=0&id=7f4d1b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4d1b0c",
  null
  
)

component.options.__file = "SvgLogo.vue"
export default component.exports